import { render, staticRenderFns } from "./RecommendationsTab.vue?vue&type=template&id=2e5f9e80&scoped=true"
import script from "./RecommendationsTab.vue?vue&type=script&lang=js"
export * from "./RecommendationsTab.vue?vue&type=script&lang=js"
import style0 from "./RecommendationsTab.vue?vue&type=style&index=0&id=2e5f9e80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5f9e80",
  null
  
)

export default component.exports